import styled from 'styled-components'
import { SpecialOutlineButtonLink } from '@chegg-wt/core/theme/fanta/button'

export const PlagiarismContainer = styled.div.attrs({
  role: 'region',
  'aria-label': 'Plagiarism Card',
})`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  padding: 24px;
  padding-top: 0;
  > h2 {
    margin-left: 0;
  }
`

export const H2 = styled.h2`
  font-weight: ${({ theme }) => theme.font.weight.extraBold};
  font-size: ${({ theme }) => theme.font.text.size.xlg};
  margin: ${({ theme }) => theme.spacing.lg};
`

export const GPContentWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const PlagiarizedPaperImage = styled.img`
  display: none;
  @media (min-width: 480px) {
    display: inline-block;
    height: 152px;
    width: 120px;
  }
`

export const GPFeatureWrapper = styled.div`
  @media (min-width: 480px) {
    padding-left: 24px;
  }
`

export const FeatureListContainer = styled.ul`
  width: 450px; /* allow this list to be more centered and share consistent styling for different sized lists */

  @media (max-width: 999px) {
    width: auto;
  }
`

export const CTAContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

export const CTAButton = styled(SpecialOutlineButtonLink)`
  display: inline-block;
  height: auto;
  padding: 5px;
  line-height: 22px;
  margin-top: 24px;
`

export const TermsWrapper = styled.div`
  padding-top: 10px;
`
